<app-material>
    <div class="header" header>
        <div class="title">
            <h2>{{ 'atom.tool-returns.inspect-details.scanner.label' | translate }}</h2>
        </div>
        <div class="details">
            <app-display-label
                [label]="'atom.tool-returns.inspect-details.display.toolRequest' | translate"
                [value]="toolReturn.toolRequest?.name">
            </app-display-label>
            <app-display-label
                [label]="'atom.tool-returns.inspect-details.display.line' | translate"
                [value]="toolReturn.line?.name">
            </app-display-label>
            <app-display-label
                [label]="'atom.tool-returns.inspect-details.display.createdBy' | translate"
                [value]="toolReturn.createdBy?.fullName">
            </app-display-label>
            <app-display-label
                [label]="'atom.tool-returns.inspect-details.display.createdDate' | translate"
                [value]="toolReturn.createdDate">
            </app-display-label>
            <app-display-label class="tool-return-reason"
                               label="{{ getLabel(toolReturn) | translate}}"
                               [value]="toolReturn.reason">
            </app-display-label>
        </div>
    </div>
    <div class="body" body>
        <app-loading-spinner *ngIf="isLoading && !isModalOpen()" class="loader"></app-loading-spinner>
        <ng-container *ngIf="!isForMaintenance; else maintenanceTemplate">
            <form *ngIf="!isLoading" [formGroup]="inspectForm">
                <app-tool-inspect-tree
                    [loading]="isLoading"
                    [isMaterial]="false"
                    [isScanEnabled]="true"
                    [isScanListenerActive]="isScanListenerActive"
                    [emptyMessage]="emptyMessage | translate"
                    [noToolsMessage]="'atom.tool-returns.inspect-details.scanner.allToolsAtLine' | translate"
                    [formControl]="inspectForm.controls['scannedTools']"
                    [showErrors]="showValidations"
                    [items]="toolReturn.returnTools"
                    (itemNotFound)="onItemNotFound($event)"
                    (toolSelect)="onToolScanned($event)"
                    (toolsSelected)="onToolsScanned($event)"
                    (rowAlertClick)="onRowAlertClick($event)">
                </app-tool-inspect-tree>
            </form>
        </ng-container>
    </div>
    <div class="footer" footer>
        <app-button *ngIf="!isLoading"
                    type="simple"
                    class="deep-orange"
                    (click)="onBackPressed()">{{ 'generic.buttons.back' | translate }}
        </app-button>
        <div class="buttons">
            <app-button *ngIf="!isLoading && !isForMaintenance"
                        type="primary"
                        class="approve-button"
                        onclick="this.blur()"
                        [disabled]="inspectForm.invalid && showValidations || hasConfirmationInProgress"
                        (clicked)="approveToolReturn()">{{ 'generic.buttons.approveForLift'| translate }}
            </app-button>
            <app-button *ngIf="!isLoading && !isForMaintenance && !this.toolReturn.hasSeveralReturnOptions"
                        type="primary"
                        class="approve-button"
                        onclick="this.blur()"
                        [disabled]="hasConfirmationInProgress"
                        (clicked)="sendToolsToService()">
                {{ 'generic.buttons.sendToolsToService'| translate }}
            </app-button>
            <app-button *ngIf="!isLoading && this.toolReturn.hasSeveralReturnOptions"
                        type="primary"
                        class="approve-button"
                        onclick="this.blur()"
                        [disabled]="inspectForm.invalid && showValidations || hasConfirmationInProgress"
                        (clicked)="approveToolReturnForService()">{{ 'generic.buttons.approveForService'| translate }}
            </app-button>
        </div>
    </div>
</app-material>
<app-issue-modal
    [hasCancel]="false"
    [hasApprove]="true"
    [hasReject]="true"
    [isLoading]="isLoading"
    (promoteToTicket)="onPromoteToTicket($event)"
    (reject)="onReject($event)"
></app-issue-modal>
<app-ticket-promote-modal [hasCancel]="false"
                          [isLoading]="isLoading"
                          (create)="createTicket($event)">
</app-ticket-promote-modal>
<app-maintenace-ticket-modal
    [similarTickets]="similarTickets"
    [isLoading]="isLoading"
    [config]="tableConfig"
    (create)="createMaintenanceTicket($event)"
    (ticketCheck)="checkForSimilarTickets($event)">
</app-maintenace-ticket-modal>
<app-operations-for-return-modal (create)="onOperationInfoApproved($event)"></app-operations-for-return-modal>
<app-ticket-create-modal [similarTickets]="similarTickets"
                         [isLoading]="isLoading"
                         [config]="tableConfig"
                         (create)="createTicket($event)"
                         (ticketCheck)="checkForSimilarTickets($event)"></app-ticket-create-modal>
<app-confirmation-modal #errorModal
                        title="{{'lineSetter.toolRequest.pages.popupError' | translate }}"
                        [message]="confirmationPopupMessage"
                        [confirmOnlyMode]="true"
                        [showConfirmButton]="false ">
</app-confirmation-modal>

<ng-template #maintenanceTemplate>
    <ng-container *ngIf="!isLoading">
        <div class="maintenance-row" *ngIf="maintenanceToolsAtLineWithoutPlan.length > 0">
            <app-tool-scan-tree
                [isMaterial]="false"
                labelText="{{'lineSetter.tool-returns.maintenance.toolsWithoutMaintenanceAtLine' | translate }}"
                [items]="maintenanceToolsAtLineWithoutPlan">
            </app-tool-scan-tree>
            <app-button *ngIf="!isLoading && isForMaintenance"
                        type="primary"
                        class="approve-button"
                        onclick="this.blur()"
                        [disabled]="hasConfirmationInProgress"
                        (clicked)="approveAndCreateMaintenanceTicket(MaintenanceSelectedTools.AT_LINE_WITHOUT_PLAN)">{{ 'generic.buttons.approveAndCreateMaintenanceTicket'| translate }}
            </app-button>
        </div>
        <div class="maintenance-row" *ngIf="maintenanceToolsAtLineWithPlan.length > 0">
                <app-tool-scan-tree
                    [isMaterial]="false"
                    labelText="{{'lineSetter.tool-returns.maintenance.toolsWithMaintenanceAtLine' | translate }}"
                    [items]="maintenanceToolsAtLineWithPlan">
                </app-tool-scan-tree>
                <app-button *ngIf="!isLoading && isForMaintenance"
                            type="primary"
                            class="approve-button"
                            onclick="this.blur()"
                            [disabled]="hasConfirmationInProgress"
                            (clicked)="approveAndCreateMaintenanceTicket(MaintenanceSelectedTools.AT_LINE_WITH_PLAN)">{{ 'generic.buttons.approveAndCreateMaintenanceTicket'| translate }}
                </app-button>
        </div>
        <div class="maintenance-row" *ngIf="maintenanceToolsAtService.length > 0">
            <app-tool-scan-tree
                [isMaterial]="false"
                labelText="{{'lineSetter.tool-returns.maintenance.toolsWithMaintenanceAtService' | translate }}"
                [items]="maintenanceToolsAtService">
            </app-tool-scan-tree>
            <app-button *ngIf="!isLoading && isForMaintenance"
                        type="primary"
                        class="approve-button"
                        onclick="this.blur()"
                        [disabled]="hasConfirmationInProgress"
                        (clicked)="approveAndCreateMaintenanceTicket(MaintenanceSelectedTools.AT_SERVICE)">{{ 'generic.buttons.approveAndCreateMaintenanceTicket'| translate }}
            </app-button>
        </div>
    </ng-container>
</ng-template>
